import { IDB_reportsReadIds, IDB_reportRead, IDB_reportsDelete } from '../IDB/IDB.table.report'
import { Cust_hasSingleLocation } from '../Cust/Cust.serverPrefs'
import { Logg_createLogger } from '../Logg/Logg.Logger'
import { Auth_getStatus } from '../Auth/Auth.State'
import { getRecentForProcedureTraining } from './Rpts.getRecentForProcedureTraining'

export function Rpts_initialise() {
    pruneReports()
    window.setInterval(pruneReports, 60 * 1000)
}

async function pruneReports() {
    if (!Cust_hasSingleLocation()) return
    if (Auth_getStatus() !== 'complete') return

    const logger = Logg_createLogger(`pruneReports`)

    const allReports = await IDB_reportsReadIds()
    const uploadedReports: number[] = []

    for (const reportId of allReports) {
        const report = await IDB_reportRead(reportId)
        if (!report.uploaded) {
            logger.log(`not deleting report as has not uploaded`, {
                reportClientId: report.clientId,
                reportId: report.onlineId,
            })
            continue
        }
        logger.log(`report can be deleted`, { reportClientId: report.clientId, reportId: report.onlineId })
        uploadedReports.push(reportId)
    }

    const recentTrainingReports = await getRecentForProcedureTraining()
    const completedTrainingForProcedure: number[] = recentTrainingReports.flatMap((data) =>
        data.training.map((t) => t.report.report)
    )

    // Remove all uploaded reports except the latest one for the procedure training
    const reportsToDelete = uploadedReports.filter((r) => !completedTrainingForProcedure.includes(r))
    await IDB_reportsDelete(logger, reportsToDelete)
}
